import { defineMessages } from 'react-intl';

export default defineMessages({
  asset: 'Asset',
  yourWalletBalance: 'Your wallet balance',
});
